import {Card} from "./Card";
import { GoogleAddressAutocomplete } from "../../helpers/GoogleAddressAutocomplete"
import { Dropdown } from '../../components/Dropdown'

let template = require('./SponsorshipCard.twig');

export class SponsorshipCard extends Card
{
    constructor() {
        super();
        this.dom = $(twig({data: template}).render({
            company_key: app.appData.companyKey
        }));

        this.drawCountryStateDD(this.dom.find('.mailing_country_dd'), this.dom.find('.mailing_state_dd'));
        this.renderDemographicDropdown();

        $(this.dom).find('.postalcode').mask('99999')
        $(this.dom).find('.phonenumber').mask('(000) 000-0000')
        $(this.dom).find('.phonenumber').attr('pattern', '^([0-9]){10}$')

        this.dom.find('input, textarea').on('keyup', () => this.cardFilledOutTriggers());
        this.dom.find('input[type=checkbox], input[type=radio]').on('click', () => this.cardFilledOutTriggers());
        this.dom.on('change', 'input, select, textarea', () => this.cardFilledOutTriggers() );

        this.dom.find('input[type=checkbox], input[type=radio]').on('change', () => {
            this.handleOtherFields();
        });
    }

    renderDemographicDropdown() {

        let specialtyDD = new Dropdown(
            app.format.getSortedSpecialties()
        );

        specialtyDD
            .addClass('input-group-text')
            .addClass('form-control-sm')
            .draw(
                this.dom.find("#hcp_patient_demographic_specialty-dd-container"),
                'short_name',
                'short_name',
                'hcp_patient_demographic_specialty'
            );

        let specialtySelect = this.dom.find('#hcp_patient_demographic_specialty');
        specialtySelect.attr('multiple', true);

        specialtySelect.select2({
            placeholder: 'Select Specialty...',
            dropdownParent: this.dom,
            width: '100%'
        });
        specialtySelect.val([]).trigger('change');
    }

    show() {
        super.show();
        const specialtySelect = this.dom.find('#hcp_patient_demographic_specialty');
        specialtySelect.val(null).trigger('change');
        new GoogleAddressAutocomplete('sponsorship_card');
    }

    isFilledOut() {
        let filled_out = true;
        let checkbox = ['type_of_org'];

        if (app.appData.companyKey == 'itf') {

            checkbox.push(
                'sponsorship_benefits',
                'kam_business_rationale'
            );
            let requiredTextareas = [
                'planned_itf_attendees'
            ];

            $.each(requiredTextareas, (i, name) => {
                let el = this.dom.find(`[name="${name}"]`);

                el.removeClass('is-invalid');

                if (!el.val() || !el.val().trim()) {
                    el.addClass('is-invalid');
                    filled_out = false;
                }
            });

            let requiredSelects = [
                'section_501c3',
                'primary_geographic_reach',
                'materials_used'
            ];

            $.each(requiredSelects, (i, name) => {

                let el = this.dom.find(`[name="${name}"]`);

                el.removeClass('is-invalid');

                if (!el.val()) {
                    el.addClass('is-invalid');
                    filled_out = false;
                }
            });

            const demographicSpecialty = this.dom
                .find('[name="hcp_patient_demographic_specialty"]');

            demographicSpecialty.removeClass('is-invalid');

            if (
                !demographicSpecialty.val() ||
                demographicSpecialty.val().length === 0
            ) {
                demographicSpecialty.addClass('is-invalid');
                filled_out = false;
            }

        } else {

            checkbox.push(
                'type_of_req',
                'tangible_benefit'
            );
        }

        this.dom.find('input[type!=checkbox][type!=radio].required, select.required, textarea.required').each((i, element) => {
            let pattern = $(element).attr('pattern');
            let regex =  null;
            if(pattern) {
                regex =  new RegExp(pattern);
            }

            $(element).removeClass('is-invalid');
            if(element.value == '' || (regex && element.value && !$(element).cleanVal().toString().match(regex)))
            {
                $(element).addClass('is-invalid');
                filled_out = false;
            }
        });

        $.each(checkbox, (i, name) => {
            if(!this.dom.find('input[name="'+name+'"]:checked').length) {
                filled_out = false;
            }
        })

        return filled_out;
    }

    getData() {
        let sponsorship_data = {};
        if(this.dom.is(':visible')) {
            this.dom.find('input, select, textarea').each((i, e) => {
                let name = $(e).attr('name');
                let type = $(e).attr('type');
                if (type == 'checkbox') {
                    if ($(e).is(':checked')) {
                        if (sponsorship_data[name] == undefined) {
                            sponsorship_data[name] = new Array();
                        }
                        sponsorship_data[name].push($(e).val());
                    }
                } else if (type == 'radio') {
                    if ($(e).is(':checked')) {
                        sponsorship_data[name] = $(e).val();
                    }
                } else if ($(e).val()) {
                    sponsorship_data[name] = $(e).val()
                }
            })
        }

        return sponsorship_data;
	}

    handleOtherFields() {
        const self = this;

        this.dom.find('input.other').each(function () {

            let input = $(this);
            let name = input.attr('name');

            let container = input.closest('.form-group').next('.form-group');
            let textInput = container.find('input');

            let isChecked = self.dom.find(
                `input[name="${name}"]:checked[value="Other"]`
            ).length > 0;

            if (isChecked) {
                container.show();
                textInput.addClass('required');
            } else {
                container.hide();
                textInput.removeClass('required is-invalid');
                textInput.val('');
            }
        });
    }
}
